// extracted by mini-css-extract-plugin
export default {"line-scale":"styles_line-scale__YrxT7","fullPageLoader":"styles_fullPageLoader__LksqI"};